// 星春大吉 右邊欄
'use client';

import { OFFICIAL_URL } from '@/common/constant';
import { useSelector } from 'react-redux';
import { urlState } from '@/slices/urlSlice';
import styles from '../../../app/event/lunar-new-year-2026/page.module.scss';
import { downloadSeatDemo } from '@/common/eventUtil';

const LunarYearRightWrapper = () => {
    const { forumUrl } = useSelector(urlState);
    // 投稿 tagId
    const tagId = forumUrl?.includes('local') ? 283 : forumUrl?.includes('pubgame') ? 561 : 7901;

    return (
        <div className="flex flex-col items-end gap-y-[22px]">
            <div className="w-full max-w-[360px]">
                <a
                    href={forumUrl + `/post?tagId=${tagId}&tag=2026星春大吉圍爐排桌`}
                    className={`aspect-[360/305] group bg-contain bg-center bg-no-repeat block
                        bg-[url(https://cdn.sounova.com/assets/event/year/flex_0.webp)] relative ${styles.flex}`}
                >
                    <img
                        className={`absolute w-[54%] left-[51%] top-[8%] translate-x-[-50%] z-[1] ${styles.monster}`}
                        src={OFFICIAL_URL.LUNAR_YEAR_CDN_BASE + 'angel.png'}
                        alt="angel"
                    />

                    <img
                        className="absolute left-[50%] w-[72%] translate-x-[-50%] bottom-[15%]"
                        src={OFFICIAL_URL.LUNAR_YEAR_CDN_BASE + 'my_1.png'}
                        alt="button"
                    />
                    <img
                        className="absolute left-[50%] w-[72%] translate-x-[-50%] bottom-[15%] trans group-hover:opacity-[0]"
                        src={OFFICIAL_URL.LUNAR_YEAR_CDN_BASE + 'my_0.png'}
                        alt="button"
                    />
                </a>
            </div>

            <div className="flex items-center gap-x-[5%] w-full max-w-[360px] px-[15px] [&>*]:trans [&>*:hover]:opacity-[.7]">
                <button onClick={downloadSeatDemo}>
                    <img src={OFFICIAL_URL.LUNAR_YEAR_CDN_BASE + 'pattern.png'} alt="download" />
                </button>

                {/* 話題頁連結 */}
                <a href={forumUrl + `/topics/lunar-new-year-2026`}>
                    <img src={OFFICIAL_URL.LUNAR_YEAR_CDN_BASE + 'popular.png'} alt="download" />
                </a>
            </div>
        </div>
    );
};

export default LunarYearRightWrapper;
